import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {CssTemplateService} from "../../services/css-template-service";
import {
    DxAccordionModule,
    DxButtonModule,
    DxPopupModule,
    DxTabPanelModule, DxTextAreaModule,
    DxTextBoxModule
} from "devextreme-angular";
import {CssTemplateDto, CssTemplateVersionDto} from "../../model/Theme";

@Component({
    selector: "css-template-versions",
    imports: [
        DxAccordionModule,
        DxTextAreaModule,
        DxTextBoxModule,
        DxButtonModule,
        DxPopupModule,
        DxTabPanelModule,
    ],
    templateUrl: "./css-template-versions.component.html",
    styleUrls: ["./css-template-versions.component.scss"]
})
export class CssTemplateVersionsComponent implements OnInit {
    @Output() exitVersion: EventEmitter<any> = new EventEmitter<any>();
    @Output() restoredVersion: EventEmitter<any> = new EventEmitter<any>();
    @Input() template!: CssTemplateDto;
    versions: any;

    constructor(
        private cssTemplateService: CssTemplateService
    ) {}

    ngOnInit() {
        if (!this.template || !this.template.id) return;
        this.cssTemplateService.getVersions(this.template.id).subscribe((data: CssTemplateVersionDto[]) => {
            data.pop();
            this.versions = data.sort(
                (a, b) => b.createdOn - a.createdOn
            );
        });
    }

    onRestore(versiondata: any) {
        this.restoredVersion.emit(versiondata);
    }

    getCreationDate(date: number) {
        return new Date(date).toLocaleString();
    }

    onExit() {
        this.exitVersion.emit(true);
    }
}